<template>
    <FormControl
        label="Role"
        :error="
            errors?.getValidationError(RequestBodyKeyEnum.App_CompanyUser_Role)
        "
    >
        <SelectInput
            :disabled="companyUser?.cannotChangeRole()"
            :name="RequestBodyKeyEnum.App_CompanyUser_Role"
            :value="dummyRole"
        >
            <option :value="UserRoleEnum.Member">
                {{ UserRoleEnum.Member }}
            </option>
            <option :value="UserRoleEnum.Admin">
                {{ UserRoleEnum.Admin }}
            </option>
            <option
                disabled
                :value="UserRoleEnum.Owner"
            >
                {{ UserRoleEnum.Owner }}
            </option>
        </SelectInput>
        <input
            v-if="companyUser?.cannotChangeRole()"
            type="hidden"
            :name="RequestBodyKeyEnum.App_CompanyUser_Role"
            :value="UserRoleEnum.Owner"
        />
    </FormControl>

    <FormControl
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_CompanyUser_IsEnabled,
            )
        "
    >
        <CheckboxInput
            label="Active"
            :name="RequestBodyKeyEnum.App_CompanyUser_IsEnabled"
            :checked="companyUser ? companyUser.isEnabled : true"
        />
    </FormControl>
</template>

<script setup lang="ts">
    import { type PropType, ref } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import CheckboxInput from '@/Shared/Component/Forms/CheckboxInput.vue'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import { UserRoleEnum } from '@/Shared/AutoGenerated/Main'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        companyUser: {
            type: Object as PropType<CompanyUser | null>,
            default: null,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })

    const dummyRole = ref<string>(
        props.companyUser?.role ?? UserRoleEnum.Member,
    )
</script>
